import FormField from '../../../../forms/fields/FormField';
import OptionField from '../../../../forms/fields/OptionField';
import CreditNoteRefundOnArticleResolutionPanel from './panels/CreditNoteRefundOnArticleResolutionPanel';
import CreditNoteRefundOnOrderTotalResolutionPanel from './panels/CreditNoteRefundOnOrderTotalResolutionPanel';

class ResolutionKindsPanels {
    constructor() {
        this._kinds = [
            {
                value: 'CREDIT_NOTE_REFUND_ON_ARTICLE',
                label: 'Nota de Crédito - % sobre artículo',
                Panel: CreditNoteRefundOnArticleResolutionPanel,
                buildFields: ({articleOptions, initialValues = {}}) => ({
                    refundArticleId: new OptionField(articleOptions, false, undefined, initialValues.refundArticleId),
                    percentage: new FormField(false, initialValues.percentage ?? ''),
                }),
            },
            {
                value: 'CREDIT_NOTE_REFUND_ON_ORDER_TOTAL',
                label: 'Nota de Crédito - % sobre total',
                Panel: CreditNoteRefundOnOrderTotalResolutionPanel,
                buildFields: ({initialValues = {}}) => ({
                    percentage: new FormField(false, initialValues.percentage ?? ''),
                }),
            },
        ];
    }

    options() {
        return this._kinds.map(kind => ({label: kind.label, value: kind.value}));
    }

    panelFor(value) {
        return this._kindWith(value)?.Panel;
    }

    buildFieldsFor(value, formOptions) {
        return this._kindWith(value)?.buildFields(formOptions);
    }

    _kindWith(value) {
        return this._kinds.find(kind => kind.value === value);
    }
}

export default ResolutionKindsPanels;
